import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/my_company_members/AccessRights.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import autobind from 'autobind-decorator';
import { __, mapStateToProps } from '../../core/utils';
import classNames from 'classnames';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import AccessRightsForm from '../../forms/my_company_members/AccessRightsForm';

@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
}))
@subscribe(Localization, 'localization')
class AccessRights extends Component {
  @autobind
  _handleSubmit(formData) {
    const {
      flyout: { details, compensation },
    } = this.props.table;

    const role_ids = formData?.role_ids;

    // assignUserRoles({ role_ids }, user?.id);

    formData = {
      ...formData,

      user_id: details?.id,
      firstname: details?.firstname,
      lastname: details?.lastname,
      start_date: compensation?.start_date || null,
      end_date: compensation?.end_date || null,
    };

    // return validateForm(
    //   updateCompanyMemberDetails(formData).then(() => {
    //     this.props.readAction();
    //     setNotification(__('my-company-members.properties.saved'));
    //   })
    // );
  }
  render() {
    const { data, collapsed, localization } = this.props;

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        <AccessRightsForm
          onSubmit={this._handleSubmit}
          data={data}
          localization={localization}
          initialValues={{
            user_id: data.details?.id,
            roles: data.roles.map((r) => r.id),
          }}
        />
      </div>
    );
  }
}

export default AccessRights;
